export default "/images/black-days-bg-mobile.png?67a97be3fb409baf6c3cb894ee21c64f";